import React from 'react';
import { Row, TBody } from '~/web-frontend-components/line/outcomes/additional/tables/TBody';
import { CELL_STYLE } from '~/web-frontend-core/api/const/base';
const MainLine = (props) => <Row {...props} tr={props.mainLine}/>;
const Body = (props) => <TBody {...props} rows={props.mainTable.map((row) => addOffset(row, props.rowOffest))}/>;
export default { MainLine, Body };
function addOffset(row, length) {
    if (!length) {
        return row;
    }
    return Array
        .from({ length })
        .map(() => ({ st: CELL_STYLE.TEXT }))
        .concat(row);
}



// WEBPACK FOOTER //
// ./src/web-frontend-components/line/outcomes/HeadTable.jsx